"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MasterValidationService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("typeorm");
const get_entity_utils_1 = require("./get-entity.utils");
let MasterValidationService = class MasterValidationService {
    constructor(dataSource) {
        this.dataSource = dataSource;
    }
    async validateMasterIds(payload, masterData) {
        try {
            const extractIdsToValidate = (obj, masterData, parentField = "") => {
                const ids = [];
                for (const [field, value] of Object.entries(obj)) {
                    if (Array.isArray(value)) {
                        // Handle arrays by iterating through each element
                        value.forEach((item) => {
                            ids.push(...extractIdsToValidate(item, masterData, `${parentField}${field}.`));
                        });
                    }
                    else if (typeof value === "object" && value !== null) {
                        // Recursively handle nested objects
                        ids.push(...extractIdsToValidate(value, masterData, `${parentField}${field}.`));
                    }
                    else if (masterData[field] !== undefined && value !== null) {
                        // Add the field if it matches the masterData
                        ids.push({
                            id: value,
                            entity: masterData[field],
                            field: `${parentField}${field}`,
                        });
                    }
                }
                return ids;
            };
            const idsToValidate = extractIdsToValidate(payload, masterData);
            // Group IDs by entity for batch validation
            const groupedIds = {};
            idsToValidate.forEach(({ id, entity }) => {
                if (!groupedIds[entity]) {
                    groupedIds[entity] = [];
                }
                groupedIds[entity].push(id);
            });
            // Validate IDs for each entity
            for (const [entityName, ids] of Object.entries(groupedIds)) {
                const entity = (0, get_entity_utils_1.getEntityByName)(entityName);
                const repository = this.dataSource.getRepository(entity);
                const primaryColumn = repository.metadata.primaryColumns[0]?.propertyName;
                if (!primaryColumn) {
                    throw new common_1.BadRequestException(`Primary key column not found for the entity ${entityName}.`);
                }
                // Fetch all valid IDs from the master table
                const validIds = await repository.find({
                    where: { [primaryColumn]: (0, typeorm_1.In)(ids) },
                    select: [primaryColumn],
                });
                const validIdSet = new Set(validIds.map((item) => item[primaryColumn]));
                // Check for invalid IDs
                ids.forEach((id) => {
                    if (!validIdSet.has(id)) {
                        const invalidField = idsToValidate.find((item) => item.id === id)?.field;
                        throw new common_1.BadRequestException(`Validation error: The value '${id}' for the field '${invalidField}' does not exist in the '${entityName}' entity.`);
                    }
                });
            }
        }
        catch (error) {
            if (error instanceof common_1.BadRequestException) {
                throw error;
            }
            throw new common_1.BadRequestException(error.message);
        }
    }
};
exports.MasterValidationService = MasterValidationService;
exports.MasterValidationService = MasterValidationService = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_1.DataSource !== "undefined" && typeorm_1.DataSource) === "function" ? _a : Object])
], MasterValidationService);
